import { useDispatch } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom"
import { logout } from "../reducers/loginReducers";

const MySideBar = () => {

    const handleSidebarLinkClick = (id) => {
        const allSideMenu = document.querySelectorAll('.sidebar-links-li');
        allSideMenu.forEach((el) => {
            el.classList.remove("active")
        })
        document.getElementById(id).classList.add("active")
    }

    const dispatch = useDispatch();
    const navigate = useNavigate()

    const onLogoutClick = () => {
        dispatch(logout());
        localStorage.removeItem("infinity_user")
        if(window.location.toString().includes("/my") || window.location.toString().includes("/user") || window.location.toString().includes("/course")){
            navigate("/")
        }
    }

    return (
        <div id="sidebar">

            <div className="nav-heading"><b>Hope Education</b> </div>
            <ul className="side-menu top">
                <li id="dashboard-sidebar-link" className="sidebar-links-li">
                    <NavLink to="/my" className="sidebar-links"
                        onClick={() => handleSidebarLinkClick("dashboard-sidebar-link")}>
                        <i className='bx bxs-shopping-bag-alt' ></i>
                        Dashboards
                    </NavLink>
                </li>
                <li id="my-courses-sidebar-link" className="sidebar-links-li">
                    <NavLink to="/user/courses" className="sidebar-links"
                        onClick={() => handleSidebarLinkClick("my-courses-sidebar-link")}>
                        <i className='bx bxs-shopping-bag-alt' ></i>
                        My Courses
                    </NavLink>
                </li>
                <li id="my-profile-sidebar-link" className="sidebar-links-li">
                    <NavLink to="/user/profile" className="sidebar-links"
                        onClick={() => handleSidebarLinkClick("my-profile-sidebar-link")}>
                        <i className='bx bxs-shopping-bag-alt' ></i>
                        My Profile
                    </NavLink>
                </li>
                <li id="my-downloads-sidebar-link" className="sidebar-links-li">
                    <NavLink to="/user/downloads" className="sidebar-links"
                        onClick={() => handleSidebarLinkClick("my-downloads-sidebar-link")}>
                        <i className='bx bxs-shopping-bag-alt' ></i>
                        My Downloads
                    </NavLink>
                </li>
                <li id="my-courses-sidebar-link" className="sidebar-links-li">

                    <a className=" sidebar-links logout" onClick={onLogoutClick}>
                        <i className='bx bxs-shopping-bag-alt' ></i>
                        Logout
                    </a>
                </li>
            </ul>
        </div>
    )
}

export default MySideBar